import styled from 'styled-components';

// Standard Row
export const StyledRow = styled.div<{margin?: string}>`
    width: 90%;
    display: flex;
    flex-direction: row;
    margin: ${props=> props.margin? props.margin: '30px auto 0 auto'};
`;
// export const Row = styled.div<{margin?: string}>`
//   margin: ${props => props.margin || '10px auto 0 auto'};
// `;

